import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import {
  getTeamGuid,
  getNumberOfMembersFromTeamData,
} from '../../selectors/apiSelectors';

const linkFundraisingPage = (frpId: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.LINK_FUNDRAISING_PAGE;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state) as string;
    const response = await makeRequest(
      `${
        config.pagesAPI
      }v1/teams/${teamGuid}/eligibleFundraiserPages/${frpId}/link`,
      {
        method: 'POST',
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.LINK_FUNDRAISING_PAGE);
    }

    dispatch(
      apiActions.updateNumberOfMembers(
        getNumberOfMembersFromTeamData(state) + 1,
      ),
    );
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
  }
};

export default linkFundraisingPage;
